import request from "@/utils/request";
import service from '@/utils/axios-v2'

export function getLoads(params) {
    return request({
        baseURL: process.env.VUE_APP_COMMAND_CENTER,
        url: "/zuul/dashboard/v2/load/get/state",
        method: 'post',
        data: params,
        headers: {
            "portal-token": true
        }
    });
}

export function getDriverCount(params) {
    return request({
        baseURL: process.env.VUE_APP_COMMAND_CENTER,
        url: "/zuul/dashboard/v2/web/count",
        // params: params,
        method: 'post',
        data: params,
        headers: {
            "portal-token": true
        }
    });
}

export function getActivityLIst(data) {
    return request({
        url: "/fleet/driver/activity/v2/web/list/dashboard",
        method: 'POST',
        data: data,
        headers: {
            "portal-token": true
        }
    });
}

export function getActivityPageList(data) {
    return request({
        url: "/fleet/driver/activity/v2/web/page/dashboard\n",
        method: 'POST',
        data: data,
        headers: {
            "portal-token": true
        }
    });
}
export function getActivityListByPage(data) {
    return request({
        baseURL: process.env.VUE_APP_COMMAND_CENTER,
        url: "/zuul/dashboard/v3/web/list/dashboard",
        method: 'post',
        data: data,
        headers: {
            "portal-token": true
        }
    });
}

export function getCarrierList() {
    return request({
      baseURL: process.env.VUE_APP_COMMAND_CENTER,
      url: `/zuul/carrier/list/for/dispatcher`,
      method: "get",
      headers: {
        "portal-token": true,
      }
    });
  }
  
  export function getDriverGps(data) {
    return request({
      baseURL: process.env.VUE_APP_COMMAND_CENTER,
      url: `/zuul/latest/gps/info`,
      method: "post",
      data: data,
      headers: {
        "portal-token": true,
      }
    });
  }

export function getDashboardLoad(data) {
    return service({
      baseURL: process.env.VUE_APP_COMMAND_CENTER,
      url: `/zuul/v2/load/query?type=map`,
      method: "post",
      data: data,
      headers: {
        "portal-token": true,
      }
    });
}